var CONFIG = {
  dev: {
    tracking_url: 'https://nsq-api-public.dev.buzzfeed.io',
    debug: true
  },
  test: {
    tracking_url: 'https://nsq-api-public.dev.buzzfeed.io',
    debug: true
  },
  stage: {
    tracking_url: 'https://pixiedust-stage.buzzfeed.com',
    debug: true
  },
  prod: {
    tracking_url: 'https://pixiedust.buzzfeed.com',
    debug: false
  },
  'app-west': {
    tracking_url: 'https://pixiedust.buzzfeed.com',
    debug: false
  }
};
var CONTEXT_PAGE_IDS = {
  HOMEPAGE: 1,
  USER: 2,
  SECTION: 3,
  TAG: 4,
  // collection
  BADGE: 5,
  TOPIC: 6,
  SEARCH: 7
};
var CONTEXT_PAGE_IDS_NEWS = {
  home: 1,
  user: 2,
  section: 3,
  collection: 4,
  topic: 5
}; // Example:
// https://github.com/buzzfeed/mono/blob/5618cec392f340ecd535d2462128e69f8b2ff774/data_registry_api/datatypes/client_tracking_events/web_pageviews_bf.yml#L132

var CONTEXT_PAGE_TYPES = {
  BUZZ: 'buzz',
  FEED: 'feed',
  USER: 'user',
  VIDEO: 'video'
}; // Example
// https://github.com/buzzfeed/mono/blob/5618cec392f340ecd535d2462128e69f8b2ff774/data_registry_api/datatypes/client_tracking_events/web_impressions_bf_amp.yml#L148-L161

var ITEM_TYPES = {
  BUZZ: 'buzz',
  VIDEO: 'video',
  SPLASH: 'splash',
  PACKAGE_CTA: 'package_cta',
  PACKAGE_SPLASH: 'package_splash'
};
var GLOBAL_NAMESPACE = 'CLIENT_EVENT_TRACKING';

export { CONFIG, CONTEXT_PAGE_IDS, CONTEXT_PAGE_IDS_NEWS, CONTEXT_PAGE_TYPES, GLOBAL_NAMESPACE, ITEM_TYPES };
